export default {
    // 中
    zhCN: {
        organization_code: '组织CODE',
        organization_name: '组织名称',
        country: '国家',
        superior_code: '上级代码',
        import_org_relships: '导入组织关系',
        vehicle_platform: '车型平台',
        replaceImagePrompt: '该车型已存在图片，是否替换？',
        publish_set: '发布设置',
        publish_content: '发布内容',
        bus_pol_exp: '运营政策说明',
        bus_pol_exp_must: '说明未填写！',
        feature_img: '特征图片',
        creator: '创建人',
        create_org: '创建组织',
        publish_role: '发布角色',
        publish_target: '发布对象',
        publish_model: '发布车型',
        model_year: '年款',
        email_notification: '是否邮件通知',
        target_hierarchy: '目标层级',
        title: '标题',
        pending_approval: '待审批',
        pending_processing: '待处理',
        my: '我的',
        all: '全部',
        draft_box: '草稿箱',
        record_export: '记录导出',
        creation_date: '创建日期',
        last_modified_time: '最后一次修改时间',
        user_name: '用户名称',
        can_view: '是否可看',
        pub_user_info: '发布用户信息',
        email_user_info: '邮件用户信息',
        pub_user: '发布用户',
        email_user: '邮件用户',
        mark_processed: '标记已处理',
        tab_name: '页签名称',
        copy_language: '副本语言',
        localization: '本地化',
        submit_approval: '提交审批',
        refuse: '拒绝',
        agree: '同意',
        codename: '代号',
        tec_Anno_exp: '技术公告说明',
        background: '背景',
        video: '视频',
        fileRemark: '文件说明',
        ple_pub_main_ann_first: '请先发布主公告！',
        repair_guide: '维修指导',
        repair_guide_summary: '维修指导简述',
        repair_guide_Info: '维修指导说明',
        custSyms: '客户症状',
        ser_pro_desc: '服务流程说明',
        sub_veh_pol_Info: '代步车政策说明',
        software_update_info: '车辆软件升级说明',
        tec_announcement: '技术公告',
        tec_announcement_summary: '技术公告简述',
        dia_software: '诊断软件',
        dia_software_summary: '诊断软件简述',
        dia_software_info: '诊断软件说明',
        software_update: '车辆软件升级',
        software_update_summary: '车辆软件升级简述',
        repair_guide_menu: '维修指导',
        business_policy: '运营政策',
        business_policy_summary: '运营政策简述',
        service_process: '服务流程',
        service_process_summary: '服务流程简述',
        sub_veh_policy: '代步车政策',
        sub_veh_policy_summary: '代步车政策简述',
        pdi_guidance: 'PDI指导',
        pdi_guidance_summary: 'PDI指导简述',
        pdi_guidance_info: 'PDI指导说明',
        latest: '最新的',
        assemblyVideos: '拆装视频',
        assemblyVideos_summary: '拆装视频简述',
        assemblyVideos_info: '拆装视频说明',
        enclosure: '附件',
        newToolsEquipment: '新工具设备',
        newToolsEquipment_summary: '新工具设备简述',
        newToolsEquipment_info: '新工具设备说明',
        claim_hours: '索赔工时',
        sys_Announcement: '系统公告',
        sys_Announcement_summary: '系统公告简述',
        sys_Announcement_info: '系统公告说明',
        announcementHomepageImage: '公告首页图片',
        claim_Announcement: '服务公告',
        claim_Announcement_summary: '服务公告简述',
        claim_Announcement_info: '服务公告说明',
        parts_Announcement: '配件公告',
        parts_Announcement_summary: '配件公告简述',
        parts_Announcement_info: '配件公告说明',
        user_manual: '用户手册',
        user_manual_summary: '用户手册简述',
        user_manual_info: '用户手册说明',
        maintenance_information: '维修资料',
        maintenance_information_summary: '维修资料简述',
        maintenance_information_info: '维修资料说明',
        redirect: '跳转',
        other_software: '其他软件',
        other_software_summary: '其他软件简述',
        other_software_info: '其他软件说明',
        priority: '优先级',
        notification_set: '通知设置',
        show_image: '展示图片',
        related_announcement: '关联公告',
    },
    // 英
    enUS: {
        organization_code: 'Organization Code',
        organization_name: 'Organization Name',
        country: 'Country',
        superior_code: 'Superior Code',
        import_org_relships: 'Import org structure',
        vehicle_platform: 'Vehicle platform',
        replaceImagePrompt: 'This model already has an image. Do you want to replace it?',
        publish_set: 'Publish Settings',
        publish_content: 'Publish Content',
        bus_pol_exp: 'Explanation of Operating Policies',
        bus_pol_exp_must: 'Description Not Filled!',
        feature_img: 'Feature Image',
        creator: 'Creator',
        create_org: 'Create Organization',
        publish_role: 'Publish Role',
        publish_target: 'Publish Target',
        publish_model: 'Publish Model',
        model_year: 'Model Year',
        email_notification: 'Email Notification',
        target_hierarchy: 'Target Hierarchy',
        title: 'Title',
        pending_approval: 'Pending Approval',
        pending_processing: 'Pending Processing',
        my: 'My',
        all: 'All',
        draft_box: 'Draft Box',
        record_export: 'Record Export',
        creation_date: 'Creation Date',
        last_modified_time: 'Last Modified Time',
        user_name: 'User Name',
        can_view: 'Can View',
        pub_user_info: 'Publish User Information',
        email_user_info: 'Email User Information',
        pub_user: 'Publish User', // 英语
        email_user: 'Email User',
        mark_processed: 'Mark as Processed',
        tab_name: 'Tab Name',
        copy_language: 'Copy Language',
        localization: 'Localization',
        submit_approval: 'Submit approval',
        refuse: 'Refuse',
        agree: 'Agree',
        codename: 'Codename',
        tec_Anno_exp: 'Technical Announcement Explanation',
        background: 'Background',
        video: 'Video',
        fileRemark: 'File Description',
        ple_pub_main_ann_first: 'Please publish the main announcement first',
        repair_guide: 'Repair Guide',
        repair_guide_summary: 'Repair Guide Summary',
        repair_guide_Info: 'Repair Guide Info',
        custSyms: 'Customer Symptoms',
        ser_pro_desc: 'Service Process Description',
        sub_veh_pol_Info: 'Substitute Vehicle Policy Info',
        software_update_info: 'Software Update Info',
        tec_announcement: 'Technical Announcement',
        tec_announcement_summary: 'Technical Announcement Summary',
        dia_software: 'Diagnostic Software',
        dia_software_summary: 'Diagnostic Software Summary',
        dia_software_info: 'Diagnostic Software Info',
        software_update: 'Software Update',
        software_update_summary: 'Software Update Summary',
        repair_guide_menu: 'Repair Guide',
        business_policy: 'Betriebsrichtlinien',
        business_policy_summary: 'Brief Overview of Operating Policies',
        service_process: 'Service Process',
        service_process_summary: 'Service Process Summary',
        sub_veh_policy: 'Substitute Vehicle Policy',
        sub_veh_policy_summary: 'Substitute Vehicle Policy Summary',
        pdi_guidance: 'PDI Guidance',
        pdi_guidance_summary: 'PDI Guidance Summary',
        pdi_guidance_info: 'PDI Guidance Notes',
        latest: 'Latest',
        assemblyVideos: 'Assembly Videos',
        assemblyVideos_summary: 'Assembly Videos Summary',
        assemblyVideos_info: 'Assembly Video Guide',
        enclosure: 'Attachment',
        newToolsEquipment: 'New Tools',
        newToolsEquipment_summary: 'New Tools Summary',
        newToolsEquipment_info: 'New Tools Info',
        claim_hours: 'Claim Hours',
        sys_Announcement: 'Sys Ann.',
        sys_Announcement_summary: 'Sys Ann. Summary',
        sys_Announcement_info: 'Sys Ann. Info',
        announcementHomepageImage: 'Ann. Home Img',
        claim_Announcement: 'Service Announcement',
        claim_Announcement_summary: 'Brief Summary of Service Announcement',
        claim_Announcement_info: 'Explanation of Service Announcement',
        parts_Announcement: 'Parts Ann.',
        parts_Announcement_summary: 'Parts Ann. Summary',
        parts_Announcement_info: 'Parts Ann. Info',
        user_manual: 'User Manual',
        user_manual_summary: 'User Manual Summary',
        user_manual_info: 'User Manual Info',
        maintenance_information: 'Maintenance Information',
        maintenance_information_summary: 'Maintenance Information Summary',
        maintenance_information_info: 'Maintenance Information Info',
        redirect: 'Redirect',
        other_software: 'Other Software',
        other_software_summary: 'Brief Description of Other Software',
        other_software_info: 'Description of Other Software',
        priority: 'Priority',
        notification_set: 'Notification Settings',
        show_image: 'Show Image',
        related_announcement: 'Related Announcement',
    },
    // 德
    deDE: {
        organization_code: 'Organisationscode',
        organization_name: 'Organisationsname',
        country: 'Land',
        superior_code: 'Übergeordneter Code',
        import_org_relships: 'Organisationsstruktur Importieren',
        vehicle_platform: 'Fahrzeugplattform',
        replaceImagePrompt: 'Dieses Modell hat bereits ein Bild. Möchten Sie es ersetzen?',
        publish_set: 'Veröffentlichungseinstellungen',
        publish_content: 'Veröffentlichung des Inhalts',
        bus_pol_exp: 'Erklärung der Betriebsrichtlinien',
        bus_pol_exp_must: 'Beschreibung nicht ausgefüllt!',
        feature_img: 'Featured Image',
        creator: 'Ersteller',
        create_org: 'Organisation erstellen',
        publish_role: 'Rolle veröffentlichen',
        publish_target: 'Veröffentlichungsziel',
        publish_model: 'Modell veröffentlichen',
        model_year: 'Modelljahr',
        email_notification: 'E-Mail-Benachrichtigung',
        target_hierarchy: 'Zielhierarchie',
        title: 'Titel',
        pending_approval: 'Zur Genehmigung ausstehend',
        pending_processing: 'Zur Bearbeitung ausstehend',
        my: 'Meine',
        all: 'Alle',
        draft_box: 'Entwurfsbox',
        record_export: 'Aufzeichnung Exportieren',
        creation_date: 'Erstellungsdatum',
        last_modified_time: 'Letzte Änderungszeit',
        user_name: 'Benutzer Name',
        can_view: 'Kann anzeigen',
        pub_user_info: 'Veröffentlichen von Benutzerinformationen',
        email_user_info: 'E-Mail-Benutzerinformationen',
        pub_user: 'Benutzer veröffentlichen',
        email_user: 'E-Mail-Ben',
        mark_processed: 'Als verarbeitet markieren',
        tab_name: 'Tab-Name',
        copy_language: 'Sprache kopieren',
        localization: 'Lokalisierung',
        submit_approval: 'Zur Prüfung',
        refuse: 'Ablehnen',
        agree: 'Zustimmen ',
        codename: 'Codename',
        tec_Anno_exp: 'Technische Bekanntmachung Erklärung',
        background: 'Hintergrund',
        video: 'Video',
        fileRemark: 'Dateibeschreibung',
        ple_pub_main_ann_first: 'Bitte veröffentlichen Sie zuerst die wichtigste Ankündigung!',
        repair_guide: 'Wartungsanleitung',
        repair_guide_summary: 'Wartungsanleitung Zusammenfassung',
        repair_guide_Info: 'Wartungsanleitung',
        custSyms: 'Kundensymptome',
        ser_pro_desc: 'Beschreibung des Serviceprozesses',
        sub_veh_pol_Info: 'Ersatzfahrzeug-Richtlinie Info',
        software_update_info: 'Software-Update-Info',
        tec_announcement: 'Technische Ankündigung',
        tec_announcement_summary: 'Technische Ankündigung Zusammenfassung',
        dia_software: 'Diagnose-Software',
        dia_software_summary: 'Diagnose-Software Zusammenfassung',
        dia_software_info: 'Erklärung zur Diagnose-Software',
        software_update: 'Fahrzeug-Update',
        software_update_summary: 'Fahrzeug-Update Zusammenfassung',
        repair_guide_menu: 'Wartungsanleitung',
        business_policy: 'Betriebsrichtlinien',
        business_policy_summary: 'Kurzübersicht der Betriebsrichtlinien',
        service_process: 'Serviceablauf',
        service_process_summary: 'Serviceablauf Zusammenfassung',
        sub_veh_policy: 'Ersatzfahrzeug-Richtl.',
        sub_veh_policy_summary: 'Ersatzfahrzeug-Richtl. Zusammenfassung',
        pdi_guidance: 'PDI-Leitfaden',
        pdi_guidance_summary: 'PDI-Leitfaden Zusammenfassung',
        pdi_guidance_info: 'PDI-Benutzerhandbuch',
        latest: 'Neueste',
        assemblyVideos: 'Demontage',
        assemblyVideos_summary: 'Demontage Zusammenfassung',
        assemblyVideos_info: 'Montage Videoanleitung',
        enclosure: 'Anlage',
        newToolsEquipment: 'Neue Werkzeuge',
        newToolsEquipment_summary: 'Neue Werkzeuge Zusammenfassung',
        newToolsEquipment_info: 'Info zu neuen Werkzeugen',
        claim_hours: 'Stundensaldo reklamieren',
        sys_Announcement: 'Sys-Mitteilung',
        sys_Announcement_summary: 'Sys-Mitteilung Zsg.',
        sys_Announcement_info: 'Sys-Mitteilung Besch.',
        announcementHomepageImage: 'Ank. Startbild',
        claim_Announcement: 'Serviceankündigung',
        claim_Announcement_summary: 'Kurzübersicht der Serviceankündigung',
        claim_Announcement_info: 'Erklärung der Serviceankündigung',
        parts_Announcement: 'Teileankündigung',
        parts_Announcement_summary: 'Kurze Teileankündigung',
        parts_Announcement_info: 'Informationen zur Teileankündigung',
        user_manual: 'Benutzerhandbuch',
        user_manual_summary: 'Zusammenfassung des Benutzerhandbuchs',
        user_manual_info: 'Informationen zum Benutzerhandbuch',
        maintenance_information: 'Wartungsinformationen',
        maintenance_information_summary: 'Zusammenfassung der Wartungsinformationen',
        maintenance_information_info: 'Informationen zu Wartungsinformationen',
        redirect: 'Weiterleitung',
        other_software: 'Andere Software',
        other_software_summary: 'Kurzbeschreibung anderer Software',
        other_software_info: 'Beschreibung anderer Software',
        priority: 'Priorität',
        notification_set: 'Benachrichtigungseinstellungen',
        show_image: 'Bild anzeigen',
        related_announcement: 'Zugehörige Ankündigung',
    },
    // 法
    frFR: {
        organization_code: 'Code organisation',
        organization_name: 'Nom organisation',
        country: 'Pays',
        superior_code: 'Code supérieur',
        import_org_relships: 'Importer structure org',
        vehicle_platform: 'Plate-forme de véhicule',
        replaceImagePrompt: 'Ce modèle a déjà une image. Voulez-vous la remplacer ?',
        publish_set: 'Paramètres de publication',
        publish_content: 'Contenu publié',
        bus_pol_exp: 'Explication des Politiques d\'Exploitation',
        bus_pol_exp_must: 'Description non renseignée!',
        feature_img: 'Image principale',
        creator: 'Créateur',
        create_org: 'Créer une organisation',
        publish_role: 'Publier le rôle',
        publish_target: 'Cible de publication',
        publish_model: 'Publier le modèle',
        model_year: 'Année modèle',
        email_notification: 'Notification par email',
        target_hierarchy: 'Hiérarchie cible',
        title: 'Titre',
        pending_approval: 'En attente d\'approbation',
        pending_processing: 'En attente de traitement',
        my: 'Mes',
        all: 'Tous',
        draft_box: 'Boîte de brouillon',
        record_export: 'Exporter l\'enregistrement',
        creation_date: 'Date de création',
        last_modified_time: 'Dernière modification',
        user_name: 'Nom d\'utilisateur',
        can_view: 'Peut voir',
        pub_user_info: 'Publier les informations utilisateur',
        email_user_info: 'Informations utilisateur par e-mail',
        pub_user: 'Publier un utilisateur',
        email_user: 'Util. e-mail',
        mark_processed: 'Marquer comme traité',
        tab_name: 'Nom de l\'onglet',
        copy_language: 'Langue de copie',
        localization: 'Localisation',
        submit_approval: 'Soum. App.',
        refuse: 'Refuser',
        agree: 'Accepter',
        codename: 'Nom de code',
        tec_Anno_exp: 'Explication de l\'Annonce Technique',
        background: 'Contexte',
        video: 'Vidéo',
        fileRemark: 'Description du fichier',
        ple_pub_main_ann_first: 'Veuillez publier l\'annonce principale en premier !',
        repair_guide: 'Guide de réparation',
        repair_guide_summary: 'Guide de réparation résumé',
        repair_guide_Info: 'Instructions de maintenance',
        custSyms: 'Symptômes du client',
        ser_pro_desc: 'Description du processus de service',
        sub_veh_pol_Info: 'Info sur la politique de véhicule de remplacement',
        software_update_info: 'Info sur la mise à jour logicielle',
        tec_announcement: 'Annonce technique',
        tec_announcement_summary: 'Annonce technique résumé',
        dia_software: 'Logiciel de diagnostic',
        dia_software_summary: 'Logiciel de diagnostic résumé',
        dia_software_info: 'Description du logiciel de diagnostic',
        software_update: 'Mise à jour véhicule',
        software_update_summary: 'Mise à jour véhicule résumé',
        repair_guide_menu: 'Guide de réparation',
        business_policy: 'Politiques d\'Exploitation',
        business_policy_summary: 'Aperçu Bref des Politiques d\'Exploitation',
        service_process: 'Processus de service',
        service_process_summary: 'Processus de service résumé',
        sub_veh_policy: 'Politique VR',
        sub_veh_policy_summary: 'Politique VR résumé',
        pdi_guidance: 'Orientation PDI',
        pdi_guidance_summary: 'Orientation PDI résumé',
        pdi_guidance_info: 'Instructions PDI',
        latest: 'Dernière',
        assemblyVideos: 'Démontage',
        assemblyVideos_summary: 'Démontage résumé',
        assemblyVideos_info: 'Guide vid. démont.',
        enclosure: 'Pièces jointes',
        newToolsEquipment: 'Nouveaux outils',
        newToolsEquipment_summary: 'Nouveaux outils résumé',
        newToolsEquipment_info: 'Info nouveaux outils',
        claim_hours: 'Demander des heures',
        sys_Announcement: 'Annonce Sys',
        sys_Announcement_summary: 'Résumé Sys',
        sys_Announcement_info: 'Descr. Sys',
        announcementHomepageImage: 'Img Accueil Ann.',
        claim_Announcement: 'Annonce de Service',
        claim_Announcement_summary: 'Aperçu Bref de l\'Annonce de Service',
        claim_Announcement_info: 'Explication de l\'Annonce de Service',
        parts_Announcement: 'Annonce de pièces',
        parts_Announcement_summary: 'Résumé de l\'annonce de pièces',
        parts_Announcement_info: 'Informations sur l\'annonce de pièces',
        user_manual: 'Manuel d\'utilisateur',
        user_manual_summary: 'Résumé du manuel d\'utilisateur',
        user_manual_info: 'Informations sur le manuel d\'utilisateur',
        maintenance_information: 'Informations sur l\'entretien',
        maintenance_information_summary: 'Résumé des informations sur l\'entretien',
        maintenance_information_info: 'Informations sur les informations d\'entretien',
        redirect: 'Redirection',
        other_software: 'Autres Logiciels',
        other_software_summary: 'Brève description des autres logiciels',
        other_software_info: 'Description des autres logiciels',
        priority: 'Priorité',
        notification_set: 'Paramètres de notification',
        show_image: 'Afficher l\'image',
        related_announcement: 'Annonce Associée',
    },
    // 意大利
    itIT: {
        organization_code: 'Codice Organizzazione',
        organization_name: 'Nome Organizzazione',
        country: 'Paese',
        superior_code: 'Code supérieur',
        import_org_relships: 'Importa struttura org',
        vehicle_platform: 'Piattaforma veicolo',
        replaceImagePrompt: 'Questo modello ha già un\'immagine. Vuoi sostituirla?',
        publish_set: 'Impostazioni di pubblicazione',
        publish_content: 'Contenuto pubblicato',
        bus_pol_exp: 'Spiegazione delle Politiche Operative',
        bus_pol_exp_must: 'Descrizione non compilata!',
        feature_img: 'Immagine in evidenza',
        creator: 'Creatore',
        create_org: 'Crea organizzazione',
        publish_role: 'Pubblicare il ruolo',
        publish_target: 'Obiettivo di pubblicazione',
        publish_model: 'Pubblicare il modello',
        model_year: 'Anno modello',
        email_notification: 'Notifica via email',
        target_hierarchy: 'Gerarchia target',
        title: 'Titolo',
        pending_approval: 'In attesa di approvazione',
        pending_processing: 'In attesa di elaborazione',
        my: 'Mio',
        all: 'Tutti',
        draft_box: 'Cassetto delle bozze',
        record_export: 'Esportazione registri',
        creation_date: 'Data di creazione',
        last_modified_time: 'Ultima modifica',
        user_name: 'Nome utente',
        can_view: 'Può visualizzare',
        pub_user_info: 'Pubblica informazioni utente',
        email_user_info: 'Informazioni utente via email',
        pub_user: 'Pubblica utente',
        email_user: 'Utente e-mail',
        mark_processed: 'Contrassegna come elaborato',
        tab_name: 'Nome della scheda',
        copy_language: 'Lingua di copia',
        localization: 'Localizzazione',
        submit_approval: 'Invia App.',
        refuse: 'Rifiutare',
        agree: 'Convenire',
        codename: 'Nome in codice',
        tec_Anno_exp: 'Spiegazione dell\'Annuncio Tecnico',
        background: 'Contesto',
        video: 'Video',
        fileRemark: 'Descrizione del file',
        ple_pub_main_ann_first: 'Per favore, pubblica prima l\'annuncio principale!',
        repair_guide: 'Guida alla riparazione',
        repair_guide_summary: 'Guida alla riparazione Riassunto',
        repair_guide_Info: 'Istruzioni di manutenzione',
        custSyms: 'Sintomi del cliente',
        ser_pro_desc: 'Descrizione del processo di servizio',
        sub_veh_pol_Info: 'Info sulla politica del veicolo di sostituzione',
        software_update_info: 'Info sull\'aggiornamento software',
        tec_announcement: 'Annunci tecnici',
        tec_announcement_summary: 'Annunci tecnici Riassunto',
        dia_software: 'Software diagnostico',
        dia_software_summary: 'Software diagnostico Riassunto',
        dia_software_info: 'Descrizione del software diagnostico',
        software_update: 'Agg. veicolo',
        software_update_summary: 'Agg. veicolo Riassunto',
        repair_guide_menu: 'Guida alla manutenzione',
        business_policy: 'Politiche Operative',
        business_policy_summary: 'Panoramica Breve delle Politiche Operative',
        service_process: 'Flusso di servizio',
        service_process_summary: 'Flusso di servizio Riassunto',
        sub_veh_policy: 'Politica VS',
        sub_veh_policy_summary: 'Politica VS Riassunto',
        pdi_guidance: 'Guida PDI',
        pdi_guidance_summary: 'Guida PDI Riassunto',
        pdi_guidance_info: 'Istruzioni PDI',
        latest: 'Ultima',
        assemblyVideos: 'Smontaggio',
        assemblyVideos_summary: 'Smontaggio Riassunto',
        assemblyVideos_info: 'Guida vid. smont.',
        enclosure: 'Allegato',
        newToolsEquipment: 'Nuovi strumenti',
        newToolsEquipment_summary: 'Nuovi strumenti Riassunto',
        newToolsEquipment_info: 'Info nuovi strumenti',
        claim_hours: 'Ore di reclamo',
        sys_Announcement: 'Annuncio Sys',
        sys_Announcement_summary: 'Riass. Sys',
        sys_Announcement_info: 'Descr. Sys',
        announcementHomepageImage: 'Img Home Ann.',
        claim_Announcement: 'Annuncio del Servizio',
        claim_Announcement_summary: 'Panoramica Breve dell\'Annuncio del Servizio',
        claim_Announcement_info: 'Spiegazione dell\'Annuncio del Servizio',
        parts_Announcement: 'Annunci di pezzi',
        parts_Announcement_summary: 'Riepilogo degli annunci di pezzi',
        parts_Announcement_info: 'Informazioni sugli annunci di pezzi',
        user_manual: 'Manuale dell\'utente',
        user_manual_summary: 'Riepilogo del manuale dell\'utente',
        user_manual_info: 'Informazioni sul manuale dell\'utente',
        maintenance_information: 'Informazioni sulla manutenzione',
        maintenance_information_summary: 'Riepilogo delle informazioni sulla manutenzione',
        maintenance_information_info: 'Informazioni sulle informazioni di manutenzione',
        redirect: 'Reindirizzamento',
        other_software: 'Altri Software',
        other_software_summary: 'Breve descrizione di altri software',
        other_software_info: 'Descrizione degli altri software',
        priority: 'Priorità',
        notification_set: 'Impostazioni Notifica',
        show_image: 'Mostra Immagine',
        related_announcement: 'Annuncio Correlato',
    },
    // 荷兰
    nlNL: {
        organization_code: 'Organisatie code',
        organization_name: 'Organisatie naam',
        country: 'Land',
        superior_code: 'Bovenliggende Code',
        import_org_relships: 'Importeer org-structuur',
        vehicle_platform: 'Voertuig platform',
        replaceImagePrompt: 'Dit model heeft al een afbeelding. Wilt u deze vervangen?',
        publish_set: 'Publicatie-instellingen',
        publish_content: 'Gepubliceerd inhoud',
        bus_pol_exp: 'Uitleg van Operationele Beleidsregels',
        bus_pol_exp_must: 'Omschrijving niet ingevuld!',
        feature_img: 'Uitgelichte afbeelding',
        creator: 'Maker',
        create_org: 'Organisatie maken',
        publish_role: 'Rol publiceren',
        publish_target: 'Publicatiedoel',
        publish_model: 'Model publiceren',
        model_year: 'Modeljaar',
        email_notification: 'E-mail notificatie',
        target_hierarchy: 'Doel hiërarchie',
        title: 'Titel',
        pending_approval: 'In afwachting van goedkeuring',
        pending_processing: 'In afwachting van verwerking',
        my: 'Mijn',
        all: 'Alle',
        draft_box: 'Conceptenbak',
        record_export: 'Record Exporteren',
        creation_date: 'Datum van creatie',
        last_modified_time: 'Laatste wijzigingstijd',
        user_name: 'Gebruikersnaam',
        can_view: 'Kan bekijken',
        pub_user_info: 'Publiceer gebruikersinformatie',
        email_user_info: 'E-mail gebruikersinformatie',
        pub_user: 'Publiceer gebruiker',
        email_user: 'E-mail-gebr.',
        mark_processed: 'Markeren als verwerkt',
        tab_name: 'Tabbladnaam',
        copy_language: 'Kopie taal',
        localization: 'Lokalisatie',
        submit_approval: 'Indienen',
        refuse: 'Weigeren',
        agree: 'Overeenkomen',
        codename: 'Codenaam',
        tec_Anno_exp: 'Technische Aankondiging Uitleg',
        background: 'Achtergrond',
        video: 'Video',
        fileRemark: 'Bestandsbeschrijving',
        ple_pub_main_ann_first: 'Publiceer alsjeblieft eerst de hoofdmededeling!',
        repair_guide: 'Reparatiehandleiding',
        repair_guide_summary: 'Reparatiehandleiding Samenvatting',
        repair_guide_Info: 'Onderhoudsinstructies',
        custSyms: 'Klantklachten',
        ser_pro_desc: 'Beschrijving van het serviceproces',
        sub_veh_pol_Info: 'Info over vervangingsvoertuig beleid',
        software_update_info: 'Info over software-update',
        tec_announcement: 'Technische aankondiging',
        tec_announcement_summary: 'Technische aankondiging Samenvatting',
        dia_software: 'Diagnostische software',
        dia_software_summary: 'Diagnostische software Samenvatting',
        dia_software_info: 'Uitleg over diagnostische software',
        software_update: 'Voertuig update',
        software_update_summary: 'Voertuig update Samenvatting',
        repair_guide_menu: 'Reparatiehandleiding',
        business_policy: 'Operationele Beleidsregels',
        business_policy_summary: 'Korte Samenvatting van Operationele Beleidsregels',
        service_process: 'Serviceproces',
        service_process_summary: 'Serviceproces Samenvatting',
        sub_veh_policy: 'Tijdelijke auto reg.',
        sub_veh_policy_summary: 'Tijdelijke auto reg. Samenvatting',
        pdi_guidance: 'PDI-Richtlijn',
        pdi_guidance_summary: 'PDI-Richtlijn Samenvatting',
        pdi_guidance_info: 'PDI-gebruikershandleiding',
        latest: 'Nieuwste',
        assemblyVideos: 'Demontage',
        assemblyVideos_summary: 'Demontage Samenvatting',
        assemblyVideos_info: 'Montage videogids',
        enclosure: 'Bijlage',
        newToolsEquipment: 'Nieuwe tools',
        newToolsEquipment_summary: 'Nieuwe tools Samenvatting',
        newToolsEquipment_info: 'Info nieuwe tools',
        claim_hours: 'Uren claimen',
        sys_Announcement: 'Sys-Bericht',
        sys_Announcement_summary: 'Samenv. Sys',
        sys_Announcement_info: 'Omschr. Sys',
        announcementHomepageImage: 'Startafbeelding Ann.',
        claim_Announcement: 'Service Mededeling',
        claim_Announcement_summary: 'Korte Samenvatting van Service Mededeling',
        claim_Announcement_info: 'Uitleg van Service Mededeling',
        parts_Announcement: 'Onderdelenmededeling',
        parts_Announcement_summary: 'Samenvatting van onderdelenmededeling',
        parts_Announcement_info: 'Informatie over onderdelenmededeling',
        user_manual: 'Gebruikershandleiding',
        user_manual_summary: 'Samenvatting van de gebruikershandleiding',
        user_manual_info: 'Informatie over de gebruikershandleiding',
        maintenance_information: 'Onderhoudsinformatie',
        maintenance_information_summary: 'Samenvatting van de onderhoudsinformatie',
        maintenance_information_info: 'Informatie over onderhoudsinformatie',
        redirect: 'Doorsturen',
        other_software: 'Andere Software',
        other_software_summary: 'Korte beschrijving van andere software',
        other_software_info: 'Beschrijving van andere software',
        priority: 'Prioriteit',
        notification_set: 'Meldingsinstellingen',
        show_image: 'Afbeelding weergeven',
        related_announcement: 'Gerelateerde Aankondiging',
    },
    // 越南
    viVN: {
        organization_code: 'Mã tổ chức',
        organization_name: 'Tên tổ chức',
        country: 'Quốc gia',
        superior_code: 'Mã cấp trên',
        import_org_relships: 'Nhập cấu trúc tổ chức',
        vehicle_platform: 'Nền tảng xe',
        replaceImagePrompt: 'Mẫu xe này đã có hình ảnh. Bạn có muốn thay thế không?',
        publish_set: 'Cài đặt xuất bản',
        publish_content: 'Nội dung xuất bản',
        bus_pol_exp: 'Giải Thích Về Chính Sách Vận Hành',
        bus_pol_exp_must: 'Mô tả chưa được điền!',
        feature_img: 'Hình ảnh đặc trưng',
        creator: 'Người tạo',
        create_org: 'Tạo tổ chức',
        publish_role: 'Phát hành vai trò',
        publish_target: 'Đối tượng xuất bản',
        publish_model: 'Phát hành mẫu',
        model_year: 'Năm mẫu',
        email_notification: 'Thông báo qua email',
        target_hierarchy: 'Cấp bậc mục tiêu',
        title: 'Tiêu đề',
        pending_approval: 'Chờ phê duyệt',
        pending_processing: 'Chờ xử lý',
        my: 'Của tôi',
        all: 'Tất cả',
        draft_box: 'Hộp nháp',
        record_export: 'Xuất bản ghi',
        creation_date: 'Ngày tạo',
        last_modified_time: 'Thời gian sửa đổi cuối cùng',
        user_name: 'Tên người dùng',
        can_view: 'Có thể xem',
        pub_user_info: 'Công bố thông tin người dùng',
        email_user_info: 'Thông tin người dùng qua email',
        pub_user: 'Công bố người dùng',
        email_user: 'Ng. dùng e-mail',
        mark_processed: 'Đánh dấu là đã xử lý',
        tab_name: 'Tên tab',
        copy_language: 'Sao chép ngôn ngữ',
        localization: 'Lokal hóa',
        submit_approval: 'Gửi Duyệt',
        refuse: 'Từ chối',
        agree: 'Đồng ý',
        codename: 'Mã số',
        tec_Anno_exp: 'Giải thích Thông báo Kỹ thuật',
        background: 'Bối cảnh',
        video: 'Video',
        fileRemark: 'Mô tả tệp',
        ple_pub_main_ann_first: 'Xin vui lòng đăng thông báo chính trước!',
        repair_guide: 'Hướng dẫn sửa chữa',
        repair_guide_summary: 'Hướng dẫn sửa chữa Tóm tắt',
        repair_guide_Info: 'Hướng dẫn bảo trì',
        custSyms: 'Triệu chứng của khách hàng',
        ser_pro_desc: 'Mô tả quy trình dịch vụ',
        sub_veh_pol_Info: 'Thông tin chính sách xe thay thế',
        software_update_info: 'Thông tin cập nhật phần mềm',
        tec_announcement: 'Thông báo kỹ thuật',
        tec_announcement_summary: 'Thông báo kỹ thuật Tóm tắt',
        dia_software: 'Phần mềm chẩn đoán',
        dia_software_summary: 'Phần mềm chẩn đoán Tóm tắt',
        dia_software_info: 'Hướng dẫn phần mềm chẩn đoán',
        software_update: 'Nâng cấp xe',
        software_update_summary: 'Nâng cấp xe Tóm tắt',
        repair_guide_menu: 'Hướng dẫn sửa chữa',
        business_policy: 'Chính Sách Vận Hành',
        business_policy_summary: 'Tổng Quan Ngắn Về Chính Sách Vận Hành',
        service_process: 'Quy trình dịch vụ',
        service_process_summary: 'Quy trình dịch vụ Tóm tắt',
        sub_veh_policy: 'Chính sách xe TT',
        sub_veh_policy_summary: 'Chính sách xe TT Tóm tắt',
        pdi_guidance: 'Hướng dẫn PDI',
        pdi_guidance_summary: 'Hướng dẫn PDI Tóm tắt',
        pdi_guidance_info: 'Hướng dẫn PDI',
        latest: 'Mới nhất',
        assemblyVideos: 'Tháo Lắp',
        assemblyVideos_summary: 'Tháo Lắp Tóm tắt',
        assemblyVideos_info: 'Hướng dẫn video tháo lắp',
        enclosure: 'Tệp đính kèm',
        newToolsEquipment: 'Công cụ mới',
        newToolsEquipment_summary: 'Công cụ mới Tóm tắt',
        newToolsEquipment_info: 'Thông tin công cụ mới',
        claim_hours: 'Yêu cầu giờ làm việc',
        sys_Announcement: 'TB Hệ thống',
        sys_Announcement_summary: 'Tóm tắt TB',
        sys_Announcement_info: 'Mô tả TB',
        announcementHomepageImage: 'Hình trang chủ TB',
        claim_Announcement: 'Thông Báo Dịch Vụ',
        claim_Announcement_summary: 'Tổng Quan Ngắn Về Thông Báo Dịch Vụ',
        claim_Announcement_info: 'Giải Thích Về Thông Báo Dịch Vụ',
        parts_Announcement: 'Thông báo về phụ tùng',
        parts_Announcement_summary: 'Tóm tắt thông báo về phụ tùng',
        parts_Announcement_info: 'Thông tin về thông báo phụ tùng',
        user_manual: 'Hướng dẫn sử dụng',
        user_manual_summary: 'Tóm tắt hướng dẫn sử dụng',
        user_manual_info: 'Thông tin hướng dẫn sử dụng',
        maintenance_information: 'Thông tin bảo trì',
        maintenance_information_summary: 'Tóm tắt thông tin bảo trì',
        maintenance_information_info: 'Thông tin về thông tin bảo trì',
        redirect: 'Chuyển hướng',
        other_software: 'Phần Mềm Khác',
        other_software_summary: 'Mô tả ngắn về phần mềm khác',
        other_software_info: 'Mô tả đầy đủ về phần mềm khác',
        priority: 'Ưu tiên',
        notification_set: 'Cài đặt Thông báo',
        show_image: 'Hiển thị Hình ảnh',
        related_announcement: 'Thông báo Liên quan',
    },
    // 西班牙
    esES: {
        organization_code: 'Código de la organización',
        organization_name: 'Nombre de la organización',
        country: 'País',
        superior_code: 'Código superior',
        import_org_relships: 'Importar estructura org',
        vehicle_platform: 'Plataforma del vehículo',
        replaceImagePrompt: 'Este modelo ya tiene una imagen. ¿Quieres reemplazarla?',
        publish_set: 'Configuración de publicación',
        publish_content: 'Contenido publicado',
        bus_pol_exp: 'Explicación de las Políticas de Operación',
        bus_pol_exp_must: ' Instrucción no completada!',
        feature_img: 'Imagen destacada',
        creator: 'Creador',
        create_org: 'Crear organización',
        publish_role: 'Publicar rol',
        publish_target: 'Objetivo de publicación',
        publish_model: 'Publicar modelo',
        model_year: 'Año del modelo',
        email_notification: 'Notificación por correo electrónico',
        target_hierarchy: 'Jerarquía objetivo',
        title: 'Título',
        pending_approval: 'Pendiente de aprobación',
        pending_processing: 'Pendiente de procesamiento',
        my: 'Mi',
        all: 'Todo',
        draft_box: 'Caja de borradores',
        record_export: 'Exportar Registro',
        creation_date: 'Fecha de creación',
        last_modified_time: 'Última hora de modificación',
        user_name: 'Nombre de usuario',
        can_view: 'Puede ver',
        pub_user_info: 'Publicar información del usuario',
        email_user_info: 'Información del usuario por correo electrónico',
        pub_user: 'Publicar usuario',
        email_user: 'Usr. correo',
        mark_processed: 'Marcar como procesado',
        tab_name: 'Nombre de la pestaña',
        copy_language: 'Idioma de copia',
        localization: 'Localización',
        submit_approval: 'Env. Aprob.',
        refuse: 'Rechazar',
        agree: 'Aceptar',
        codename: 'Nombre en clave',
        tec_Anno_exp: 'Explicación del Aviso Técnico',
        background: 'Contexto',
        video: 'Video',
        fileRemark: 'Descripción de archivo',
        ple_pub_main_ann_first: '¡Por favor, publica primero el anuncio principal!',
        repair_guide: 'Guía de reparación',
        repair_guide_summary: 'Guía de reparación Resumen',
        repair_guide_Info: 'Instrucciones de mantenimiento',
        custSyms: 'Síntomas del cliente',
        ser_pro_desc: 'Descripción del proceso de servicio',
        sub_veh_pol_Info: 'Información sobre política de vehículo sustituto',
        software_update_info: 'Información sobre actualización de software',
        tec_announcement: 'Anuncio técnico',
        tec_announcement_summary: 'Anuncio técnico Resumen',
        dia_software: 'Software de diagnóstico',
        dia_software_summary: 'Software de diagnóstico Resumen',
        dia_software_info: 'Descripción del software de diagnóstico',
        software_update: 'Actualización vehículo',
        software_update_summary: 'Actualización vehículo Resumen',
        repair_guide_menu: 'Guía de reparación',
        business_policy: 'Políticas de Operación',
        business_policy_summary: 'Resumen Breve de las Políticas de Operación',
        service_process: 'Proceso de servicio',
        service_process_summary: 'Proceso de servicio Resumen',
        sub_veh_policy: 'Política VS',
        sub_veh_policy_summary: 'Política VS Resumen',
        pdi_guidance: 'Guía PDI',
        pdi_guidance_summary: 'Guía PDI Resumen',
        pdi_guidance_info: 'Instrucciones PDI',
        latest: 'Más reciente',
        assemblyVideos: 'Desmontaje',
        assemblyVideos_summary: 'Desmontaje Resumen',
        assemblyVideos_info: 'Guía vid. des.',
        enclosure: 'Adjunto',
        newToolsEquipment: 'Nuevas herramientas',
        newToolsEquipment_summary: 'Nuevas herramientas Resumen',
        newToolsEquipment_info: 'Info nuevas herramientas',
        claim_hours: 'Solicitar horas',
        sys_Announcement: 'Anuncio Sys',
        sys_Announcement_summary: 'Resumen Sys',
        sys_Announcement_info: 'Descripción Sys',
        announcementHomepageImage: 'Img Principal Ann.',
        claim_Announcement: 'Anuncio de Servicio',
        claim_Announcement_summary: 'Resumen Breve del Anuncio de Servicio',
        claim_Announcement_info: 'Explicación del Anuncio de Servicio',
        parts_Announcement: 'Anuncio de piezas',
        parts_Announcement_summary: 'Resumen del anuncio de piezas',
        parts_Announcement_info: 'Información sobre el anuncio de piezas',
        user_manual: 'Manual de usuario',
        user_manual_summary: 'Resumen del manual de usuario',
        user_manual_info: 'Información del manual de usuario',
        maintenance_information: 'Información de mantenimiento',
        maintenance_information_summary: 'Resumen de la información de mantenimiento',
        maintenance_information_info: 'Información sobre la información de mantenimiento',
        redirect: 'Redirección',
        other_software: 'Otro Software',
        other_software_summary: 'Descripción breve de otro software',
        other_software_info: 'Descripción completa de otro software',
        priority: 'Prioridad',
        notification_set: 'Configuración de Notificación',
        show_image: 'Mostrar Imagen',
        related_announcement: 'Anuncio Relacionado',
    },
    // 葡萄牙
    ptBR: {
        organization_code: 'Código da organização',
        organization_name: 'Nome da organização',
        country: 'País',
        superior_code: 'Código superior',
        import_org_relships: 'Importar estrutura org',
        vehicle_platform: 'Plataforma do veículo',
        replaceImagePrompt: 'Este modelo já possui uma imagem. Você deseja substituí-la?',
        publish_set: 'Configurações de publicação',
        publish_content: 'Conteúdo publicado',
        bus_pol_exp: 'Explicação das Políticas Operacionais',
        bus_pol_exp_must: 'Descrição não preenchida!',
        feature_img: 'Imagem em destaque',
        creator: 'Criador',
        create_org: 'Criar organização',
        publish_role: 'Publicar papel',
        publish_target: 'Objetivo de publicação',
        publish_model: 'Publicar modelo',
        model_year: 'Ano do modelo',
        email_notification: 'Notificação por e-mail',
        target_hierarchy: 'Hierarquia alvo',
        title: 'Título',
        pending_approval: 'Aguardando aprovação',
        pending_processing: 'Aguardando processamento',
        my: 'Meu',
        all: 'Tudo',
        draft_box: 'Caixa de rascunhos',
        record_export: 'Exportar Registro',
        creation_date: 'Data de criação',
        last_modified_time: 'Última hora de modificação',
        user_name: 'Nome de utilizador',
        can_view: 'Pode visualizar',
        pub_user_info: 'Publicar informações do usuário',
        email_user_info: 'Informações do usuário por e-mail',
        pub_user: 'Publicar usuário',
        email_user: 'Usu. e-mail',
        mark_processed: 'Marcar como processado',
        tab_name: 'Nome da guia',
        copy_language: 'Idioma de cópia',
        localization: 'Localização',
        submit_approval: 'Env. Aprov.',
        refuse: 'Recusar',
        agree: 'Concordar',
        codename: 'Nome de código',
        tec_Anno_exp: 'Explicação do Aviso Técnico',
        background: 'Contexto',
        video: 'Vídeo',
        fileRemark: 'Descrição do arquivo',
        ple_pub_main_ann_first: 'Por favor, publique primeiro o anúncio principal!',
        repair_guide: 'Guia de reparo',
        repair_guide_summary: 'Guia de reparo Resumo',
        repair_guide_Info: 'Instruções de manutenção',
        custSyms: 'Sintomas do cliente',
        ser_pro_desc: 'Descrição do processo de serviço',
        sub_veh_pol_Info: 'Informações sobre política de veículo substituto',
        software_update_info: 'Informações sobre atualização de software',
        tec_announcement: 'Anúncio técnico',
        tec_announcement_summary: 'Anúncio técnico Resumo',
        dia_software: 'Software de diagnóstico',
        dia_software_summary: 'Software de diagnóstico Resumo',
        dia_software_info: 'Descrição do software de diagnóstico',
        software_update: 'Atualização veículo',
        software_update_summary: 'Atualização veículo Resumo',
        repair_guide_menu: 'Guia de reparação',
        business_policy: 'Políticas Operacionais',
        business_policy_summary: 'Visão Geral Breve das Políticas Operacionais',
        service_process: 'Processo de serviço',
        service_process_summary: 'Processo de serviço Resumo',
        sub_veh_policy: 'Política VS',
        sub_veh_policy_summary: 'Política VS Resumo',
        pdi_guidance: 'Orientação PDI',
        pdi_guidance_summary: 'Orientação PDI Resumo',
        pdi_guidance_info: 'Instruções PDI',
        latest: 'Mais recente',
        assemblyVideos: 'Desmontagem',
        assemblyVideos_summary: 'Desmontagem Resumo',
        assemblyVideos_info: 'Guia vid. des.',
        enclosure: 'Anexo',
        newToolsEquipment: 'Novas ferramentas',
        newToolsEquipment_summary: 'Novas ferramentas Resumo',
        newToolsEquipment_info: 'Info novas ferramentas',
        claim_hours: 'Reivindicar horas',
        sys_Announcement: 'Anúncio Sys',
        sys_Announcement_summary: 'Resumo Sys',
        sys_Announcement_info: 'Descrição Sys',
        announcementHomepageImage: 'Img Inicial Ann.',
        claim_Announcement: 'Anúncio de Serviço',
        claim_Announcement_summary: 'Visão Geral Breve do Anúncio de Serviço',
        claim_Announcement_info: 'Explicação do Anúncio de Serviço',
        parts_Announcement: 'Anúncio de peças',
        parts_Announcement_summary: 'Resumo do anúncio de peças',
        parts_Announcement_info: 'Informações sobre o anúncio de peças',
        user_manual: 'Manual do usuário',
        user_manual_summary: 'Resumo do manual do usuário',
        user_manual_info: 'Informações do manual do usuário',
        maintenance_information: 'Informações de manutenção',
        maintenance_information_summary: 'Resumo das informações de manutenção',
        maintenance_information_info: 'Informações sobre as informações de manutenção',
        redirect: 'Redirecionamento',
        other_software: 'Outro Software',
        other_software_summary: 'Descrição breve de outro software',
        other_software_info: 'Descrição detalhada de outro software',
        priority: 'Prioridade',
        notification_set: 'Configurações de Notificação',
        show_image: 'Mostrar Imagem',
        related_announcement: 'Anúncio Relacionado',
    },
    // 波兰
    plPL: {
        organization_code: 'Kod organizacji',
        organization_name: 'Nazwa organizacji',
        country: 'Kraj',
        superior_code: 'Kod nadrzędny',
        import_org_relships: 'Importuj strukturę org',
        vehicle_platform: 'Platforma pojazdu',
        replaceImagePrompt: 'Ten model ma już obrazek. Czy chcesz go zastąpić?',
        publish_set: 'Ustawienia publikacji',
        publish_content: 'Opublikowana treść',
        bus_pol_exp: 'Wyjaśnienie Polityki Operacyjnej',
        bus_pol_exp_must: 'Opis nie wprowadzony!',
        feature_img: 'Obrazek wyróżniający',
        creator: 'Twórca',
        create_org: 'Utwórz organizację',
        publish_role: 'Opublikować rolę',
        publish_target: 'Cel publikacji',
        publish_model: 'Opublikować model',
        model_year: 'Rok modelu',
        email_notification: 'Powiadomienie e-mail',
        target_hierarchy: 'Docelowa hierarchia',
        title: 'Tytuł',
        pending_approval: 'Oczekuje na zatwierdzenie',
        pending_processing: 'Oczekuje na przetworzenie',
        my: 'Moje',
        all: 'Wszystko',
        draft_box: 'Skrzynka robocza',
        record_export: 'Eksportuj Rejestr',
        creation_date: 'Data utworzenia',
        last_modified_time: 'Ostatnia zmiana',
        user_name: 'Nazwa użytkownika',
        can_view: 'Może zobaczyć',
        pub_user_info: 'Opublikuj informacje o użytkowniku',
        email_user_info: 'Informacje o użytkowniku pocztą elektroniczną',
        pub_user: 'Opublikuj użytkownika',
        email_user: 'Uż. e-mail',
        mark_processed: 'Oznacz jako przetworzone',
        tab_name: 'Nazwa zakładki',
        copy_language: 'Język kopiowania',
        localization: 'Lokalizacja',
        submit_approval: 'Zatw. Wniosek',
        refuse: 'Odmowa',
        agree: 'Zgoda',
        codename: 'Kryptonim',
        tec_Anno_exp: 'Wyjaśnienie Ogłoszenia Technicznego',
        background: 'Tło',
        video: 'Wideo',
        fileRemark: 'Opis pliku',
        ple_pub_main_ann_first: 'Proszę najpierw opublikować główne ogłoszenie!',
        repair_guide: 'Przewodnik naprawczy',
        repair_guide_summary: 'Przewodnik naprawczy Podsumowanie',
        repair_guide_Info: 'Instrukcja konserwacji',
        custSyms: 'Objawy klienta',
        ser_pro_desc: 'Opis procesu obsługi',
        sub_veh_pol_Info: 'Informacje o polityce pojazdu zastępczego',
        software_update_info: 'Informacje o aktualizacji oprogramowania',
        tec_announcement: 'Ogłoszenie techniczne',
        tec_announcement_summary: 'Ogłoszenie techniczne Podsumowanie',
        dia_software: 'Oprogramowanie diagnostyczne',
        dia_software_summary: 'Oprogramowanie diagnostyczne Podsumowanie',
        dia_software_info: 'Opis oprogramowania diagnostycznego',
        software_update: 'Akt. pojazdu',
        software_update_summary: 'Akt. pojazdu Podsumowanie',
        repair_guide_menu: 'Przewodnik naprawczy',
        business_policy: 'Polityka Operacyjna',
        business_policy_summary: 'Krótki Przegląd Polityki Operacyjnej',
        service_process: 'Procedury obsługi',
        service_process_summary: 'Procedury obsługi Podsumowanie',
        sub_veh_policy: 'Polityka PZ',
        sub_veh_policy_summary: 'Polityka PZ Podsumowanie',
        pdi_guidance: 'Wskazówki PDI',
        pdi_guidance_summary: 'Wskazówki PDI Podsumowanie',
        pdi_guidance_info: 'Instrukcja PDI',
        latest: 'Najnowsza',
        assemblyVideos: 'Demontaż',
        assemblyVideos_summary: 'Demontaż Podsumowanie',
        assemblyVideos_info: 'Przewodnik wideo dem.',
        enclosure: 'Załącznik',
        newToolsEquipment: 'Nowe narzędzia',
        newToolsEquipment_summary: 'Nowe narzędzia Podsumowanie',
        newToolsEquipment_info: 'Info nowe narzędzia',
        claim_hours: 'Wymagać godzin',
        sys_Announcement: 'OG Sys',
        sys_Announcement_summary: 'Podsum. Sys',
        sys_Announcement_info: 'Opis Sys',
        announcementHomepageImage: 'Img Strona główna OG',
        claim_Announcement: 'Ogłoszenie o Usłudze',
        claim_Announcement_summary: 'Krótki Przegląd Ogłoszenia o Usłudze',
        claim_Announcement_info: 'Wyjaśnienie Ogłoszenia o Usłudze',
        parts_Announcement: 'Ogłoszenie o częściach',
        parts_Announcement_summary: 'Podsumowanie ogłoszenia o częściach',
        parts_Announcement_info: 'Opis ogłoszenia o akcesoriach',
        user_manual: 'Instrukcja obsługi',
        user_manual_summary: 'Podsumowanie instrukcji obsługi',
        user_manual_info: 'Informacje o instrukcji obsługi',
        maintenance_information: 'Informacje o konserwacji',
        maintenance_information_summary: 'Podsumowanie informacji o konserwacji',
        maintenance_information_info: 'Informacje o informacjach dotyczących konserwacji',
        redirect: 'Przekierowanie',
        other_software: 'Inne Oprogramowanie',
        other_software_summary: 'Kratka charakterystyka innego oprogramowania',
        other_software_info: 'Pełny opis innego oprogramowania',
        priority: 'Priorytet',
        notification_set: 'Ustawienia Powiadomień',
        show_image: 'Wyświetl Obraz',
        related_announcement: 'Powiązane Ogłoszenie',
    },
    // 土耳其
    trTR: {
        organization_code: 'Organizasyon CODE',
        organization_name: 'Organizasyon adı',
        country: 'Ülke',
        superior_code: 'Üst düzey kod',
        import_org_relships: 'Organizasyon yapısını içe aktar',
        vehicle_platform: 'Araç platformu',
        replaceImagePrompt: 'Bu modelin zaten bir resmi var. Değiştirmek ister misiniz?',
        publish_set: 'Yayın Ayarları',
        publish_content: 'Yayınlanan içerik',
        bus_pol_exp: 'İşletme Politikalarının Açıklaması',
        bus_pol_exp_must: 'Açıklama doldurulmadı!',
        feature_img: 'Öne çıkan görsel',
        creator: 'Yaratıcı',
        create_org: 'Organizasyon oluştur',
        publish_role: 'Rolü yayınla',
        publish_target: 'Yayın hedefi',
        publish_model: 'Modeli yayınla',
        model_year: 'Model yılı',
        email_notification: 'E-posta bildirimi',
        target_hierarchy: 'Hedef hiyerarşi',
        title: 'Başlık',
        pending_approval: 'Onay Bekliyor',
        pending_processing: 'İşlem Bekliyor',
        my: 'Benim',
        all: 'Tümü',
        draft_box: 'Taslak Kutusu',
        record_export: 'Kayıt dışa aktarma',
        creation_date: 'Oluşturulma Tarihi',
        last_modified_time: 'Son Düzenleme Zamanı',
        user_name: 'Kullanıcı Adı',
        can_view: 'Görüntülenebilir',
        pub_user_info: 'Kullanıcı Bilgisi Yayınla',
        email_user_info: 'E-posta ile Kullanıcı Bilgisi',
        pub_user: 'Kullanıcı Yayınla',
        email_user: 'E-posta usr.',
        mark_processed: 'İşlenmiş olarak işaretle',
        tab_name: 'Sekme Adı',
        copy_language: 'Kopya dili',
        localization: 'Yerelleştirme',
        submit_approval: 'Onaya Sun',
        refuse: 'Geri çevirme',
        agree: 'Kabul etme',
        codename: 'Kod adı',
        tec_Anno_exp: 'Teknik Duyuru Açıklaması',
        background: 'Arka plan',
        video: 'Video',
        fileRemark: 'Dosya Açıklaması',
        ple_pub_main_ann_first: 'Lütfen önce ana duyuruyu yayınlayın!',
        repair_guide: 'Onarım rehberi',
        repair_guide_summary: 'Onarım rehberi Özet',
        repair_guide_Info: 'Bakım talimatları',
        custSyms: 'Müşteri semptomları',
        ser_pro_desc: 'Servis süreci açıklaması',
        sub_veh_pol_Info: 'Değişim aracı politikası bilgisi',
        software_update_info: 'Yazılım güncelleme bilgisi',
        tec_announcement: 'Teknik duyuru',
        tec_announcement_summary: 'Teknik duyuru Özet',
        dia_software: 'Tanısal yazılım',
        dia_software_summary: 'Tanısal yazılım Özet',
        dia_software_info: 'Tanısal Yazılım Açıklaması',
        software_update: 'Araç güncelleme',
        software_update_summary: 'Araç güncelleme Özet',
        repair_guide_menu: 'Onarım Kılavuzu',
        business_policy: 'İşletme Politikaları',
        business_policy_summary: 'İşletme Politikalarına Kısa Bir Bakış',
        service_process: 'Servis süreci',
        service_process_summary: 'Servis süreci Özet',
        sub_veh_policy: 'İlgili araç pol.',
        sub_veh_policy_summary: 'İlgili araç pol. Özet',
        pdi_guidance: 'PDI Rehberi',
        pdi_guidance_summary: 'PDI Rehberi Özet',
        pdi_guidance_info: 'PDI Kullanım Kılavuzu',
        latest: 'En yeni',
        assemblyVideos: 'Montaj',
        assemblyVideos_summary: 'Montaj Özet',
        assemblyVideos_info: 'Demontaj video rehberi',
        enclosure: 'Ekli dosya',
        newToolsEquipment: 'Yeni araçlar',
        newToolsEquipment_summary: 'Yeni araçlar Özet',
        newToolsEquipment_info: 'Yeni araçlar bilgi',
        claim_hours: 'Saat talep etmek',
        sys_Announcement: 'Sys Duyuru',
        sys_Announcement_summary: 'Sys Özeti',
        sys_Announcement_info: 'Sys Açıklaması',
        announcementHomepageImage: 'Duyuru Ana Sayfa Img',
        claim_Announcement: 'Servis Duyurusu',
        claim_Announcement_summary: 'Servis Duyurusuna Kısa Bir Bakış',
        claim_Announcement_info: 'Servis Duyurusunun Açıklaması',
        parts_Announcement: 'Parça duyurusu',
        parts_Announcement_summary: 'Parça duyurusu özeti',
        parts_Announcement_info: 'Parça Duyurusu Bilgisi',
        user_manual: 'Kullanım Kılavuzu',
        user_manual_summary: 'Kullanım kılavuzu özeti',
        user_manual_info: 'Kullanım kılavuzu bilgisi',
        maintenance_information: 'Bakım Bilgileri',
        maintenance_information_summary: 'Bakım bilgileri özeti',
        maintenance_information_info: 'Bakım bilgileri hakkında bilgi',
        redirect: 'Yönlendirme',
        other_software: 'Diğer Yazılım',
        other_software_summary: 'Diğer yazılımın kısa açıklaması',
        other_software_info: 'Diğer yazılımın detaylı açıklaması',
        priority: 'Öncelik',
        notification_set: 'Bildirim Ayarları',
        show_image: 'Görseli Göster',
        related_announcement: 'İlgili Duyuru',
    },
    // 捷克语
    csCZ: {
        organization_code: 'Kód společnosti',
        organization_name: 'Název společnosti',
        country: 'Země',
        superior_code: 'Nadřazený kód',
        import_org_relships: 'Importovat strukturu org',
        vehicle_platform: 'Platforma vozidla',
        replaceImagePrompt: 'Tento model již má obrázek. Chcete jej nahradit?',
        publish_set: 'Nastavení publikování',
        publish_content: 'Publikovaný obsah',
        bus_pol_exp: 'Vysvětlení Provozních Politik',
        bus_pol_exp_must: 'Popis nebyl vyplněn!',
        feature_img: 'Vyznačený obrázek',
        creator: 'Tvůrce',
        create_org: 'Vytvořit organizaci',
        publish_role: 'Publikovat roli',
        publish_target: 'Cíl publikace',
        publish_model: 'Publikovat model',
        model_year: 'Modelový rok',
        email_notification: 'E-mailová notifikace',
        target_hierarchy: 'Cílová hierarchie',
        title: 'Název',
        pending_approval: 'Čeká na schválení',
        pending_processing: 'Čeká na zpracování',
        my: 'Moje',
        all: 'Všechny',
        draft_box: 'Složka konceptů',
        record_export: 'Exportovat záznamy',
        creation_date: 'Datum vytvoření',
        last_modified_time: 'Poslední úprava',
        user_name: 'Uživatelské jméno',
        can_view: 'Může zobrazit',
        pub_user_info: 'Publikovat informace o uživateli',
        email_user_info: 'Informace o uživateli prostřednictvím e-mailu',
        pub_user: 'Publikovat uživatele',
        email_user: 'E-mail už.',
        mark_processed: 'Označit jako zpracováno',
        tab_name: 'Název karty',
        copy_language: 'Jazyk kopírování',
        localization: 'Lokalizace',
        submit_approval: 'Ke Schválení',
        refuse: 'Odmítnout',
        agree: 'Souhlasit',
        codename: 'Kódové jméno',
        tec_Anno_exp: 'Vysvětlení Technické Oznámení',
        background: 'Kontext',
        video: 'Video',
        fileRemark: 'Popis souboru',
        ple_pub_main_ann_first: 'Prosím, nejprve publikujte hlavní oznámení!',
        repair_guide: 'Průvodce opravou',
        repair_guide_summary: 'Průvodce opravou Shrnutí',
        repair_guide_Info: 'Údržbové pokyny',
        custSyms: 'Symptomy zákazníka',
        ser_pro_desc: 'Popis procesu služby',
        sub_veh_pol_Info: 'Informace o náhradním vozidle',
        software_update_info: 'Informace o aktualizaci softwaru',
        tec_announcement: 'Technické oznámení',
        tec_announcement_summary: 'Technické oznámení Shrnutí',
        dia_software: 'Diagnostický software',
        dia_software_summary: 'Diagnostický software Shrnutí',
        dia_software_info: 'Vysvětlení diagnostického softwaru',
        software_update: 'Akt. vozidla',
        software_update_summary: 'Akt. vozidla Shrnutí',
        repair_guide_menu: 'Průvodce opravou',
        business_policy: 'Provozní Politika',
        business_policy_summary: 'Stručný Přehled Provozních Politik',
        service_process: 'Proces služeb',
        service_process_summary: 'Proces služeb Shrnutí',
        sub_veh_policy: 'Politika NV',
        sub_veh_policy_summary: 'Politika NV Shrnutí',
        pdi_guidance: 'PDI pokyny',
        pdi_guidance_summary: 'PDI pokyny Shrnutí',
        pdi_guidance_info: 'PDI návod k použití',
        latest: 'Nejnovější',
        assemblyVideos: 'Demontáž',
        assemblyVideos_summary: 'Demontáž Shrnutí',
        assemblyVideos_info: 'Průvodce videa dem.',
        enclosure: 'Příloha',
        newToolsEquipment: 'Nové nástroje',
        newToolsEquipment_summary: 'Nové nástroje Shrnutí',
        newToolsEquipment_info: 'Info nové nástroje',
        claim_hours: 'Nárokovat hodiny',
        sys_Announcement: 'Sys Oznámení',
        sys_Announcement_summary: 'Zkratka Sys',
        sys_Announcement_info: 'Popis Sys',
        announcementHomepageImage: 'Oznámení Domovská Img',
        claim_Announcement: 'Oznámení Služby',
        claim_Announcement_summary: 'Stručný Přehled Oznámení Služby',
        claim_Announcement_info: 'Vysvětlení Oznámení Služby',
        parts_Announcement: 'Oznámení o dílech',
        parts_Announcement_summary: 'Stručné oznámení o dílech',
        parts_Announcement_info: 'Informace o Oznámení Dílů',
        user_manual: 'Uživatelský manuál',
        user_manual_summary: 'Stručný uživatelský manuál',
        user_manual_info: 'Informace o uživatelském manuálu',
        maintenance_information: 'Informace o údržbě',
        maintenance_information_summary: 'Stručné informace o údržbě',
        maintenance_information_info: 'Informace o informacích o údržbě',
        redirect: 'Přesměrování',
        other_software: 'Jiný Software',
        other_software_summary: 'Stručný popis jiného softwaru',
        other_software_info: 'Podrobný popis jiného softwaru',
        priority: 'Priorita',
        notification_set: 'Nastavení oznámení',
        show_image: 'Zobrazit obrázek',
        related_announcement: 'Související Oznámení',
    },
    // 匈牙利语
    huHU: {
        organization_code: 'Szervezet kódja',
        organization_name: 'Szervezet neve',
        country: 'Ország',
        superior_code: 'Felső szintű kód',
        import_org_relships: 'Szervezeti struktúra importálása',
        vehicle_platform: 'Járműplatform',
        replaceImagePrompt: 'Ez a modell már rendelkezik képpel. Szeretné lecserélni?',
        publish_set: 'Közzétételi beállítások',
        publish_content: 'Közzétett tartalom',
        bus_pol_exp: 'Működési Szabályzat Magyarázata',
        bus_pol_exp_must: 'Leírás nem lett kitöltve!',
        feature_img: 'Kiemelt kép',
        creator: 'Létrehozó',
        create_org: 'Szervezet létrehozása',
        publish_role: 'Szerep közzététele',
        publish_target: 'Közzétételi cél',
        publish_model: 'Modell közzététele',
        model_year: 'Modell év',
        email_notification: 'E-mail értesítés',
        target_hierarchy: 'Cél hierarchia',
        title: 'Cím',
        pending_approval: 'Vár approval',
        pending_processing: 'Vár feldolgozásra',
        my: 'Az én',
        all: 'Minden',
        draft_box: 'Piszkozatok',
        record_export: 'Nyilvántartás exportálása',
        creation_date: 'Létrehozás dátuma',
        last_modified_time: 'Utolsó módosítás ideje',
        user_name: 'Felhasználónév',
        can_view: 'Megtekinthető',
        pub_user_info: 'Felhasználói információ közzététele',
        email_user_info: 'Felhasználói információ e-mailben',
        pub_user: 'Felhasználó közzététele',
        email_user: 'E-mail felh.',
        mark_processed: 'Feldolgozottként jelölés',
        tab_name: 'Fül neve',
        copy_language: 'Másolási nyelv',
        localization: 'Lokalisáció',
        submit_approval: 'Jóv. Küldés',
        refuse: 'Elutasítás',
        agree: 'Beleegyezés',
        codename: 'Kódnév',
        tec_Anno_exp: 'Műszaki Közlemény Magyarázata',
        background: 'Háttér',
        video: 'Video',
        fileRemark: 'Fájlmegjelenítés',
        ple_pub_main_ann_first: 'Kérlek, először közzészd a fő közleményt!',
        repair_guide: 'Javítási útmutató',
        repair_guide_summary: 'Javítási útmutató Kivonat',
        repair_guide_Info: 'Karbantartási útmutató',
        custSyms: 'Ügyfél tünetei',
        ser_pro_desc: 'Szerviz folyamat leírása',
        sub_veh_pol_Info: 'Helyettes jármű szabályzat információ',
        software_update_info: 'Szoftver frissítés információ',
        tec_announcement: 'Technikai közlemény',
        tec_announcement_summary: 'Technikai közlemény Kivonat',
        dia_software: 'Diagnosztikai szoftver',
        dia_software_summary: 'Diagnosztikai szoftver Kivonat',
        dia_software_info: 'Diagnosztikai szoftver leírása',
        software_update: 'Jármű frissítés',
        software_update_summary: 'Jármű frissítés Kivonat',
        repair_guide_menu: 'Karbantartási útmutató',
        business_policy: 'Működési Szabályzat',
        business_policy_summary: 'Rövid Áttekintés a Működési Szabályzatról',
        service_process: 'Szolgáltatási folyamat',
        service_process_summary: 'Szolgáltatási folyamat Kivonat',
        sub_veh_policy: 'Helyettes jármű sz.',
        sub_veh_policy_summary: 'Helyettes jármű sz. Kivonat',
        pdi_guidance: 'PDI útmutató',
        pdi_guidance_summary: 'PDI útmutató Kivonat',
        pdi_guidance_info: 'PDI használati útmutató',
        latest: 'Legfrissebb',
        assemblyVideos: 'Montáz',
        assemblyVideos_summary: 'Montáz Kivonat',
        assemblyVideos_info: 'Montáz videó útmutató',
        enclosure: 'Csatolmány',
        newToolsEquipment: 'Új eszközök',
        newToolsEquipment_summary: 'Új eszközök Kivonat',
        newToolsEquipment_info: 'Új eszközök info',
        claim_hours: 'Órák igénybevétele',
        sys_Announcement: 'Sys Bejelentés',
        sys_Announcement_summary: 'Összef. Sys',
        sys_Announcement_info: 'Leírás Sys',
        announcementHomepageImage: 'Bejelentés Kezdőlap Img',
        claim_Announcement: 'Szolgáltatási Közlemény',
        claim_Announcement_summary: 'Rövid Áttekintés a Szolgáltatási Közleményről',
        claim_Announcement_info: 'A Szolgáltatási Közlemény Magyarázata',
        parts_Announcement: 'Részek közleménye',
        parts_Announcement_summary: 'Részek közleménye összefoglalója',
        parts_Announcement_info: 'Részek Közleménye Információ',
        user_manual: 'Felhasználói kézikönyv',
        user_manual_summary: 'Felhasználói kézikönyv összefoglalója',
        user_manual_info: 'Felhasználói kézikönyv információi',
        maintenance_information: 'Karbantartási információk',
        maintenance_information_summary: 'Karbantartási információk összefoglalója',
        maintenance_information_info: 'Információk a karbantartási információkról',
        redirect: 'Átirányítás',
        other_software: 'Más Szoftver',
        other_software_summary: 'Rövid leírás más szoftverhez',
        other_software_info: 'Teljes leírás más szoftverhez',
        priority: 'Prioritás',
        notification_set: 'Értesítési beállítások',
        show_image: 'Kép megjelenítése',
        related_announcement: 'Kapcsolódó Közlemény',
    },
    // 俄罗斯
    ruRU: {
        organization_code: 'Код организации',
        organization_name: 'Название организации',
        country: 'Страна',
        superior_code: 'Верхний код',
        import_org_relships: 'Импорт структуры орг',
        vehicle_platform: 'Платформа автомобиля',
        replaceImagePrompt: 'Эта модель уже имеет изображение. Хотите заменить?',
        publish_set: 'Настройки публикации',
        publish_content: 'Опубликованный контент',
        bus_pol_exp: 'Объяснение Операционных Политик',
        bus_pol_exp_must: 'Описание не заполнено!',
        feature_img: 'Изображение по умолчанию',
        creator: 'Создатель',
        create_org: 'Создать организацию',
        publish_role: 'Опубликовать роль',
        publish_target: 'Цель публикации',
        publish_model: 'Опубликовать модель',
        model_year: 'Год модели',
        email_notification: 'Уведомление по электронной почте',
        target_hierarchy: 'Целевая иерархия',
        title: 'Заголовок',
        pending_approval: 'Ожидает утверждения',
        pending_processing: 'Ожидает обработки',
        my: 'Мои',
        all: 'Все',
        draft_box: 'Черновики',
        record_export: 'Экспорт записей',
        creation_date: 'Дата создания',
        last_modified_time: 'Последнее время изменения',
        user_name: 'Имя пользователя',
        can_view: 'Можно просматривать',
        pub_user_info: 'Публикация информации о пользователе',
        email_user_info: 'Информация о пользователе по электронной почте',
        pub_user: 'Публикация пользователя',
        email_user: 'Польз. e-mail',
        mark_processed: 'Отметить как обработано',
        tab_name: 'Название вкладки',
        copy_language: 'Язык копирования',
        localization: 'Локализация',
        submit_approval: 'На утв.',
        refuse: 'Отказать',
        agree: 'Согласовать',
        codename: 'Кодовое имя',
        tec_Anno_exp: 'Объяснение Технического Объявления',
        background: 'Фон (Fon)',
        video: 'Видео',
        fileRemark: 'Описание файла',
        ple_pub_main_ann_first: 'Пожалуйста, сначала опубликуйте главное объявление!',
        repair_guide: 'Руководство по ремонту',
        repair_guide_summary: 'Руководство по ремонту Краткое содержание',
        repair_guide_Info: 'Инструкция по обслуживанию',
        custSyms: 'Симптомы клиента',
        ser_pro_desc: 'Описание процесса обслуживания',
        sub_veh_pol_Info: 'Информация о политике замены транспортных средств',
        software_update_info: 'Информация об обновлении ПО',
        tec_announcement: 'Техническое объявление',
        tec_announcement_summary: 'Техническое объявление Краткое содержание',
        dia_software: 'Диагностическое программное обеспечение',
        dia_software_summary: 'Диагностическое программное обеспечение Краткое содержание',
        dia_software_info: 'Описание диагностического программного обеспечения',
        software_update: 'Обновление авто',
        software_update_summary: 'Обновление авто Краткое содержание',
        repair_guide_menu: 'Руководство по ремонту',
        business_policy: 'Операционные Политики',
        business_policy_summary: 'Краткий Обзор Операционных Политик',
        service_process: 'Процесс обслуживания',
        service_process_summary: 'Процесс обслуживания Краткое содержание',
        sub_veh_policy: 'Политика ВА',
        sub_veh_policy_summary: 'Политика ВА Краткое содержание',
        pdi_guidance: 'Руководство PDI',
        pdi_guidance_summary: 'Руководство PDI Краткое содержание',
        pdi_guidance_info: 'Руководство по PDI',
        latest: 'Последняя',
        assemblyVideos: 'Демонтаж',
        assemblyVideos_summary: 'Демонтаж Краткое содержание',
        assemblyVideos_info: 'Руководство видео демонтажа',
        enclosure: 'Вложение',
        newToolsEquipment: 'Новые инструменты',
        newToolsEquipment_summary: 'Новые инструменты Краткое содержание',
        newToolsEquipment_info: 'Инфо новые инструменты',
        claim_hours: 'Заявить часы',
        sys_Announcement: 'Объявление Sys',
        sys_Announcement_summary: 'Краткое Sys',
        sys_Announcement_info: 'Описание Sys',
        announcementHomepageImage: 'Объявление Главная Img',
        claim_Announcement: 'Объявление о Сервисе',
        claim_Announcement_summary: 'Краткий Обзор Объявления о Сервисе',
        claim_Announcement_info: 'Объяснение Объявления о Сервисе',
        parts_Announcement: 'Объявление о запчастях',
        parts_Announcement_summary: 'Краткое объявление о запчастях',
        parts_Announcement_info: 'Информация о Объявлении Запчастей',
        user_manual: 'Руководство пользователя',
        user_manual_summary: 'Краткое руководство пользователя',
        user_manual_info: 'Информация о руководстве пользователя',
        maintenance_information: 'Информация о техническом обслуживании',
        maintenance_information_summary: 'Краткое содержание информации о техническом обслуживании',
        maintenance_information_info: 'Информация об информации о техническом обслуживании',
        redirect: 'Перенаправление',
        other_software: 'Другое ПО',
        other_software_summary: 'Краткое описание другого ПО',
        other_software_info: 'Полное описание другого ПО',
        priority: 'Приоритет',
        notification_set: 'Настройки уведомлений',
        show_image: 'Показать изображение',
        related_announcement: 'Связанное Объявление',
    },
};
